"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("regenerator-runtime/runtime");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
require("./styles/element-variables.scss");
require("@/styles/index.scss");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
require("./icons");
require("./permission");
require("./utils/error-log");
var _lang = _interopRequireDefault(require("./lang"));
var filters = _interopRequireWildcard(require("./filters"));
var _CookieConsentManager = require("./utils/CookieConsentManager");
var _vueGtag = _interopRequireWildcard(require("vue-gtag"));
var _vueHtml2canvas = _interopRequireDefault(require("vue-html2canvas"));
var _vueSliderComponent = _interopRequireDefault(require("vue-slider-component"));
// a modern alternative to CSS resets

// global css

// icon
// permission control
// error log
// Internationalization

// global filters

_CookieConsentManager.cookieConsentManager.init({
  privacyPolicyUrl: 'https://lifehikes.com/privacy-policy/'
});
_vue.default.component('VueSlider', _vueSliderComponent.default);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV !== 'production') {
  const {
    mockXHR
  } = require('../mock');
  mockXHR();
}
_vue.default.use(_vueHtml2canvas.default);
const hasAnalyticsConsent = _CookieConsentManager.cookieConsentManager.hasConsent('analytics');
_vue.default.use(_vueGtag.default, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      cookie_domain: 'none',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied'
    }
  },
  pageTrackerScreenviewEnabled: true,
  appName: 'LifeHikes Admin Portal',
  enabled: hasAnalyticsConsent
}, _router.default);
_CookieConsentManager.cookieConsentManager.onConsentChange(() => {
  const hasConsent = _CookieConsentManager.cookieConsentManager.hasConsent('analytics');
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: hasConsent ? 'granted' : 'denied'
    });
  }
  if (hasConsent) {
    (0, _vueGtag.optIn)();
  } else {
    (0, _vueGtag.optOut)();
  }
});
_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'medium',
  // set element-ui default size
  i18n: (key, value) => _lang.default.t(key, value)
});

// register global utility filters
Object.keys(filters).forEach(key => {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: h => h(_App.default)
});